// extracted by mini-css-extract-plugin
export default {"heading":"Title_heading__CzJiE"};